/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, InputAdornment, ListItemText } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import {
  LockerExpiryText,
  LockerExpiryValue,
  StyledBox,
  StyledBoxLocker,
  StyledBoxMain,
  StyledGrid,
  StyledGridList,
  StyledList,
  StyledListItem,
  StyledIDBox,
  StyledIDText,
  StyledImageBox,
  StyledInnerBox,
  StyledItemListContainer,
  StyledLockerItemGrid,
  StyledItemsContainer,
  StyledSearchIcon,
  StyledTypographyRol,
  StyledTypographyText,
  StyledInlineLink,
} from "./style";



import LockerLogo from "../../assets/images/locker-icon.png";
import clock from "../../assets/svg/clock.svg";
import ellipse from "../../assets/images/ellipse.png";

import { StyledBoxStyle } from "../../components/common/input/style";
import { StyledNavbarSearch } from "../../components/common/navbar/style";
import CustomLocker from "../../components/list-item/ListItem";
import CustomHeader from "../../components/naming-header/CustomHeader";
import BlockLock from "../../components/block-lock/BlockLock";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/common/loader/Loader";
import {
  GET_VIRTUAL_LOCKER,
  ADD_VIRTUAL_LOCKER,
} from "../../actions/AddressActions";
import { formatName, formatToLongDate } from "../../utils/common";
import { VIRTUAL_LOCKER_GET_ITEM } from "../../actions/VirtualLockerAction";
import { CUSTOMER_ORDER_LIST } from "../../actions/OrderAction";
import {
  ADD_LOCKER_ITEMS_BLOCKED_MESSAGE,
  ORDER_PAID_ADD_ITEMS_BLOCKED_MESSAGE,
  canAddVirtualLockerItems,
  getLockerItemBlockReason,
  hasActiveCustomerOrder,
  LOCKER_EXPIRED_ITEMS_MESSAGE,
  LOCKER_INACTIVE_ITEMS_MESSAGE,
  LOCKER_INACTIVE_ONLY_MESSAGE,
  resolveLockerStatus,
} from "../../utils/orderCreateEligibility";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import SuccessVirtual from "../../components/modals/success-virtual-locker/SuccessVIrtual";
import CreateSuccessVirtual from "../../components/modals/create-success-virtual-locker/CreateSuccessVirtual";
import InactiveLockerModal from "../../components/modals/inactive-locker/InactiveLockerModal";
import {
  CREATE_ORDER_PATH,
  clearInactiveLockerModalDismiss,
  dismissInactiveLockerModal,
  isInactiveLockerModalDismissed,
} from "../../utils/inactiveLockerPrompt";

/** Same copy as SuccessVIrtual.jsx Terms & Conditions (modal section commented out) */
const VIRTUAL_LOCKER_TERMS = [
  "You will be notified via email/SMS once an item enters the locker. The 45-day storage period begins from that date.",
  "You may choose to dispatch items anytime within the 45-day window at no extra cost.",
  "Storage fees once paid are non-refundable.",
  "Native Shipper is not liable for any item after the disposal date due to non-payment or delay in dispatch.",
  "Storage fees and durations may change based on your subscription plan or promotions.",
  "For extended storage beyond 45 days, you will receive a reminder 2 days before the fee becomes due.",
];

const LockerV2 = () => {
  const [searchItem, setSearchItem] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const virtualLockerModel = useCallback(
    (values) => {
      dispatch({ type: ADD_VIRTUAL_LOCKER, payload: values });
    },
    [dispatch]
  );
  useEffect(() => {
    virtualLockerModel();
  }, [virtualLockerModel]);

  const virtualModel = useSelector((state) => state?.address?.virtualAddress);
  const lockerGetDetails = useSelector(
    (state) => state?.address?.virtualAddress
  );
  const lockerId = useSelector((state) => state?.address?.virtualAddress?.locker_id);
  const { orderSummary, hasFetchedCustomerOrderList, recordList } = useSelector(
    (state) => state?.order ?? {}
  );
  const hasActiveOrder = hasActiveCustomerOrder(
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList
  );
  const hasLocker =
    lockerGetDetails &&
    !Array.isArray(lockerGetDetails) &&
    Boolean(lockerGetDetails.locker_id);

  const [openVirtualSuccess, setOpenVirtualSuccess] = useState(false);
  const [openVirtualSuccessGet, setOpenVirtualSuccessGet] = useState(false);
  const [openInactiveModal, setOpenInactiveModal] = useState(false);

  const handleOpenVirtualSuccess = () => setOpenVirtualSuccess(true);
  const handleCloseVirtualSuccess = () => {
    setOpenVirtualSuccess(false);
    if (!lockerId) {
      navigate("/dashboard/orders");
    }
  };
  const handleAcceptVirtualSuccess = () => {
    setOpenVirtualSuccess(false);
    dispatch({
      type: GET_VIRTUAL_LOCKER,
      payload: {
        onSuccess: () => {
          setOpenVirtualSuccessGet(true);
          virtualLockerModel({
            onSuccess: (lockerData) => {
              if (!lockerData?.locker_id) {
                navigate("/dashboard/orders");
              }
            },
          });
        },
      },
    });
  };
  const handleOpenVirtualSuccessGet = () => setOpenVirtualSuccessGet(true);
  const handleCloseVirtualSuccessGet = () => setOpenVirtualSuccessGet(false);

  const isVirtualModel = !!virtualModel;

  useEffect(() => {
    dispatch({ type: CUSTOMER_ORDER_LIST, payload: { page: 1, limit: 10 } });
  }, [dispatch]);

  useEffect(() => {
    if (!hasFetchedCustomerOrderList || hasActiveOrder || hasLocker) {
      if (hasActiveOrder || hasLocker) {
        setOpenVirtualSuccess(false);
      }
      return;
    }
    if (!virtualModel) {
      handleOpenVirtualSuccess();
    }
  }, [isVirtualModel, hasLocker, hasActiveOrder, hasFetchedCustomerOrderList]);

  const getItemLocker = useCallback(
    (values) => {
      dispatch({
        type: VIRTUAL_LOCKER_GET_ITEM,
        payload: values,
      });
    },
    [dispatch]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchItem);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchItem]);

  useEffect(() => {
    getItemLocker({ product_name: debouncedSearch || undefined });
  }, [getItemLocker, debouncedSearch]);

  const getItemData = useSelector(
    (state) => state?.virtual?.lockerGetList?.data
  );
  const isLoading = useSelector((state) => state?.virtual?.isLoading);

  const canAddItems = canAddVirtualLockerItems(
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList,
    lockerGetDetails
  );
  const addItemsBlockReason =
    getLockerItemBlockReason(
      lockerGetDetails,
      orderSummary,
      hasFetchedCustomerOrderList,
      recordList
    ) || ADD_LOCKER_ITEMS_BLOCKED_MESSAGE;
  // Use stored locker status for add-item gating (do not override inactive → active).
  // Wait until locker is loaded so refresh does not flash inactive while virtualAddress is still [].
  // If there is no in-flight order (e.g. all rejected/closed), treat as inactive so
  // status + "create new order" message show even when DB still has stale "active".
  const lockerStatus = hasLocker
    ? resolveLockerStatus(lockerGetDetails)
    : null;
  const isLockerExpired = lockerStatus === "expired";
  const isLockerInactive =
    hasLocker &&
    (lockerStatus === "inactive" ||
      (!isLockerExpired &&
        hasFetchedCustomerOrderList &&
        !hasActiveOrder));

  useEffect(() => {
    if (!lockerId || isLockerInactive) return;
    clearInactiveLockerModalDismiss(lockerId);
  }, [lockerId, isLockerInactive]);

  useEffect(() => {
    if (
      !hasLocker ||
      !hasFetchedCustomerOrderList ||
      openVirtualSuccess ||
      openVirtualSuccessGet ||
      !isLockerInactive
    ) {
      setOpenInactiveModal(false);
      return;
    }
    if (isInactiveLockerModalDismissed(lockerId)) {
      setOpenInactiveModal(false);
      return;
    }
    setOpenInactiveModal(true);
  }, [
    hasLocker,
    hasFetchedCustomerOrderList,
    openVirtualSuccess,
    openVirtualSuccessGet,
    isLockerInactive,
    lockerId,
  ]);

  const handleCloseInactiveModal = () => {
    dismissInactiveLockerModal(lockerId);
    setOpenInactiveModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const hasApprovedItem = (getItemData ?? []).some(
    (item) => String(item?.status ?? "").toLowerCase() === "approved"
  );
  const today = new Date();
  const expiryDate = new Date(lockerGetDetails?.locker_expiry_date);

  let diffDays;
  if (!isNaN(expiryDate)) {
    const diffTime = expiryDate - today;
    diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  } else {
    diffDays = "Invalid date";
  }
  const inactiveMessage = hasActiveOrder
    ? LOCKER_INACTIVE_ONLY_MESSAGE
    : LOCKER_INACTIVE_ITEMS_MESSAGE;
  const handleOpen = () => {
    if (isLockerInactive) {
      if (!isInactiveLockerModalDismissed(lockerId)) {
        setOpenInactiveModal(true);
      } else {
        toast.error(inactiveMessage);
      }
      return;
    }
    if (!canAddItems) {
      toast.error(addItemsBlockReason);
      return;
    }
    navigate("/dashboard/locker/item");
  };
  const addItemsDisabled = !canAddItems || isLockerInactive;
  return (
    <>
      <StyledBoxMain>
        <CustomHeader
          title="VIRTUAL LOCKER"
          label="Add New Items"
          onClick={handleOpen}
          disabled={addItemsDisabled}
          disabledReason={
            isLockerInactive ? inactiveMessage : addItemsBlockReason
          }
          statusMessage={
            isLockerExpired
              ? LOCKER_EXPIRED_ITEMS_MESSAGE
              : addItemsBlockReason === ORDER_PAID_ADD_ITEMS_BLOCKED_MESSAGE
                ? (
                  <>
                    Your current order is in progress.{" "}
                    <StyledInlineLink to={CREATE_ORDER_PATH}>
                      Create a new order
                    </StyledInlineLink>
                    {" "}to add items.
                  </>
                )
                : isLockerInactive
                  ? (
                    hasActiveOrder
                      ? LOCKER_INACTIVE_ONLY_MESSAGE
                      : (
                        <>
                          Your virtual locker is currently inactive.{" "}
                          <StyledInlineLink to={CREATE_ORDER_PATH}>
                            Create a new order
                          </StyledInlineLink>
                          {" "}to activate your locker.
                        </>
                      )
                  )
                  : null
          }
        />
        <StyledGrid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: { xs: "16px", md: "20px 30px" }, gap: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0 }}>
                <img src={LockerLogo} alt="LockerLogo" width={80} height={80} loading="lazy" style={{ flexShrink: 0 }} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <StyledTypographyRol>Terms & Conditions</StyledTypographyRol>
                  <StyledList>
                    {VIRTUAL_LOCKER_TERMS.map((line) => (
                      <StyledListItem key={line}>
                        <ListItemText primary={line} />
                      </StyledListItem>
                    ))}
                  </StyledList>
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "center", gap: "10px", flexShrink: 0, py: 2 }}>
                {/* Upgrade hidden when any item is approved — do not remove */}
                {/* TODO: Re-enable Upgrade button in UI when upgrade/payment flow is ready. */}
                {/* {!hasApprovedItem && (
                  <CustomChip padding="9px 20px" title="Upgrade" color={theme.palette.custom.white} background={theme.palette.custom.danger} />
                )} */}
                {/* {hasApprovedItem && (
                  <CustomChip padding="9px 20px" title="Upgrade" color={theme.palette.custom.white} background={theme.palette.custom.danger} />
                )} */}
                <StyledBox>
                  {lockerGetDetails?.locker_expiry_date && !isLockerInactive && (
                    <StyledInnerBox>
                      <StyledImageBox><img loading="lazy" src={clock} alt="icon" /></StyledImageBox>
                      <StyledBoxLocker>
                        <LockerExpiryText>Locker Expiry</LockerExpiryText>
                        <LockerExpiryValue>{(diffDays<=0)? `Expired` : `${diffDays} Days`}</LockerExpiryValue>
                      </StyledBoxLocker>
                    </StyledInnerBox>
                  )}
                  {lockerGetDetails?.locker_id && (
                    <StyledIDBox>
                      {isLockerInactive || isLockerExpired ? (
                        <Box
                          component="span"
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            flexShrink: 0,
                            backgroundColor: isLockerExpired ? "#F5A623" : "#9E9E9E",
                          }}
                          aria-label={isLockerExpired ? "expired" : "inactive"}
                        />
                      ) : (
                        <img loading="lazy" width={8} height={8} src={ellipse} alt="active" />
                      )}
                      <StyledIDText>
                        {isLockerInactive
                          ? `Inactive · ID:${lockerGetDetails?.locker_id}`
                          : isLockerExpired
                            ? `Expired · ID:${lockerGetDetails?.locker_id}`
                            : `ID:${lockerGetDetails?.locker_id}`}
                      </StyledIDText>
                    </StyledIDBox>
                  )}
                </StyledBox>
              </Box>
            </Box>
          </Grid>
        </StyledGrid>

        <StyledItemListContainer>
          <StyledGridList container spacing={2}>
            <Grid size={{ lg: 6, md: 6, xs: 6 }}>
              <StyledTypographyText>List of Items</StyledTypographyText>
            </Grid>
            <Grid size={{ lg: 6, md: 6, xs: 6 }}>
              <StyledBoxStyle>
                <StyledNavbarSearch
                  placeholder="Search by Product Name"
                  variant="outlined"
                  value={searchItem}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <StyledSearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => setSearchItem(e.target.value)}
                />
              </StyledBoxStyle>
            </Grid>
          </StyledGridList>

          <Divider />
          <StyledItemsContainer>
            {isLoading ? (
              <Loader minHeight={280} size={48} />
            ) : (
              <Grid container spacing={1} alignItems="stretch">
                {getItemData?.map((item, ind) => {
                  return (
                    <StyledLockerItemGrid 
                      size={{ xl: 4, lg: 6, md: 6, sm: 12, xs: 12 }} 
                      key={item?.id}
                    >
                      <Box sx={{ width: '100%', display: 'flex' }}>
                        <CustomLocker
                          lockerView="v2"
                          ind={ind}
                          getItemLocker={getItemLocker}
                          lockerStatus={lockerStatus}
                          status={item?.status}
                          itemId={item?.id}
                          product={formatName(item?.product_name)}
                          chip1Title={item?.shelf_no}
                          createUser={item?.create_by_user}
                          quantity={item?.quantity}
                          chip2Title={formatName(item?.order_type)}
                          sendNumOrValue={formatName(item?.order_type)}
                          senderType={formatName(item?.order_type)}
                          orderType={item?.order_type}
                          createdAt={formatToLongDate(item?.createdAt)}
                          expDelivery={formatToLongDate(item?.estimated_delivery)}
                          preferredDropDate={formatToLongDate(item?.pickup_date)}
                          images={item?.product_image || []}
                          note={item?.note_to_customer}
                          customerDeclineNote={item?.customer_decline_note}
                          paymentStatus={item?.payment_status}
                        />
                      </Box>
                    </StyledLockerItemGrid>
                  );
                })}

                <StyledLockerItemGrid
                  size={{ xl: 4, lg: 6, md: 6, sm: 12, xs: 12 }}
                >
                  <Box sx={{ width: '100%', display: 'flex' }}>
                    <BlockLock
                      handleOpen={handleOpen}
                      disabled={addItemsDisabled}
                      disabledReason={
                        isLockerInactive ? inactiveMessage : addItemsBlockReason
                      }
                    />
                  </Box>
                </StyledLockerItemGrid>
              </Grid>
            )}
          </StyledItemsContainer>
        </StyledItemListContainer>
      </StyledBoxMain>
      
      {openVirtualSuccess && (
        <SuccessVirtual
          open={openVirtualSuccess}
          handleOpen={handleOpenVirtualSuccess}
          handleClose={handleCloseVirtualSuccess}
          handleAccept={handleAcceptVirtualSuccess}
        />
      )}

      {openVirtualSuccessGet && (
        <CreateSuccessVirtual
          open={openVirtualSuccessGet}
          handleOpen={handleOpenVirtualSuccessGet}
          handleClose={handleCloseVirtualSuccessGet}
        />
      )}

      {openInactiveModal && (
        <InactiveLockerModal
          open={openInactiveModal}
          onClose={handleCloseInactiveModal}
          hasExistingOrder={hasActiveOrder}
          onCreateOrder={() => {
            handleCloseInactiveModal();
            navigate(CREATE_ORDER_PATH);
          }}
        />
      )}

      {/* {openProductDetails && (
        <ProductDetails
          open={openProductDetails}
          handleOpen={handleOpenProductDetails}
          handleClose={handleCloseProductDetails}
        />
      )} */}
    </>
  );
};

export default LockerV2;
